import { useTranslation } from 'react-i18next';

import { FerrySearchForm } from '@frontend/features/travel-services/components/FerrySearchForm';
import { TravelServicesPage } from '@frontend/features/travel-services/components/TravelServicesPage';
import { useSearchFormKey } from '@frontend/features/travel-services/useSearchUrlState';

/** Buscador de ferrys (vertical ferry de Rutero). */
export const Ferry = () => {
  const { t } = useTranslation();
  // Aplicar una búsqueda reciente remonta el buscador: si no, los campos
  // (que se llenan al montar) quedarían vacíos bajo los resultados nuevos.
  const formKey = useSearchFormKey();

  return (
    <TravelServicesPage
      title={t('common.nav.ferry')}
      intro={t('travelServices.ferryIntro')}
    >
      <FerrySearchForm key={formKey} />
    </TravelServicesPage>
  );
};

export default Ferry;
